/**
 * Droit « Référent bien-être animal » (`users/{uid}.rights.bea`), décision de
 * Gwen du 04/10/2026 : ce qui était le rôle « Correspondant BEA » devient un
 * droit en plus du rôle, comme les droits vétérinaire et technique, ouvert à
 * tout compte. Il désigne la personne référente sans rien ouvrir ni fermer ;
 * un tableau de bord dédié viendra plus tard.
 *
 * Lecture compatible, sans migration : un ancien « Correspondant BEA » détient
 * le droit tant qu'un administrateur n'a pas enregistré `rights.bea`, qui fait
 * alors foi (y compris `false`). L'ancien BEA se reconnaît à `userRight.isBEA`
 * (invitations) OU à son libellé : la fiche V1 attribuait le rôle sans poser
 * `isBEA` (51 comptes « Correspondant BEA » sur aws-stage, dont 13 seulement
 * avec `isBEA`, relevé du 04/10/2026).
 */

const record = (value) => value !== null && typeof value === "object" && !Array.isArray(value);

// Libellés de l'ancien rôle, toutes langues (sous-ensemble de STOCK_ACCESS_ROLE_LABELS).
export const FORMER_BEA_ROLE_LABELS = Object.freeze([
  "Correspondant BEA", "Welfare correspondent", "BEA correspondent",
  "Tierwohl-Beauftragter", "Corresponsal de bienestar", "Correspondent welzijn",
]);
const FORMER_BEA = new Set(FORMER_BEA_ROLE_LABELS.map((label) => label.toLowerCase()));

/** Ancien rôle « Correspondant BEA » : `isBEA` ou libellé de ce rôle. */
export const isFormerBeaRole = (userRight) =>
  record(userRight) && (userRight.isBEA === true ||
    (typeof userRight.label === "string" && FORMER_BEA.has(userRight.label.normalize("NFC").trim().toLowerCase())));

/** Même choix que les règles Firestore : `rights`, sinon le champ historique `userRights`. */
const rightsOf = (user) => (record(user?.rights) ? user.rights : record(user?.userRights) ? user.userRights : {});

/**
 * @param {{ rights?: object, userRights?: object, userRight?: string | { isBEA?: boolean } }} user
 * @returns {boolean}
 */
export const hasWelfareReferentRight = (user) => {
  const rights = rightsOf(user);
  if (typeof rights.bea === "boolean") return rights.bea;
  return isFormerBeaRole(user?.userRight);
};
